import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { BaseComponent } from '@portals/core';

@Component({
	templateUrl: './dialog.component.html',
	styleUrls: ['./dialog.component.scss'],
})
// TODO: this was made with notification preview in mind, this is not a generic component, shouln't be here
// change it for NotificationPreviewComponent inside portals notification feature module.
export class DialogComponent extends BaseComponent implements OnInit {
	image: any;

	constructor(private sanitizer: DomSanitizer, @Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<DialogComponent>) {
		super();
	}

	ngOnInit(): void {
		this.image = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.image);
	}

	cancel() {
		this.dialogRef.close(false);
	}

	confirm() {
		this.dialogRef.close(true);
	}
}
